<template>
  <v-app id="app" >
    <!-- <v-layout column align-center>
        <v-flex xs12 class="container-manutencao"> 
                <v-img :src="manutencao_logo" :height="window.height/3">
                </v-img>
                <v-flex xs12>
                    <h3>EM MANUTENÇÃO</h3>
                </v-flex>
        </v-flex>
    </v-layout> -->
   
    <Menu :dense='scrolled || window.width < 1150' :collapsenav="window.width < 1070" @nav-drawer="drawer = true" @manual-eleicoes="dialog = true"/>

      <v-snackbar
              v-model="snackbar" right top :timeout="snackbarTimeout"
      >
          {{ snackbarText }}
          <v-btn color="error" flat @click="snackbar = false" >
              x
          </v-btn>
      </v-snackbar>

      <v-navigation-drawer
              v-model="drawer"
              fixed
              right
              temporary
      >
          <v-list class="pa-1">
              <v-list-tile href="/#quemsomos" @click="">
                  <v-list-tile-action>
                      Quem Somos
                  </v-list-tile-action>
              </v-list-tile>
              <v-list-tile href="/#advogados" @click="">
                  <v-list-tile-action>
                      Advogados
                  </v-list-tile-action>

              </v-list-tile>
              <v-list-tile href="/#solucoes" @click="">
                  <v-list-tile-action>
                      Soluções
                  </v-list-tile-action>

              </v-list-tile>
              
              <!-- <v-list-tile href="/#publicacoes" @click="">
                  <v-list-tile-action>
                      Publicações
                  </v-list-tile-action>

              </v-list-tile> -->
              <v-list-tile href="/#contato" @click="">
                  <v-list-tile-action>
                      Contato
                  </v-list-tile-action>

              </v-list-tile >
              <v-list-tile @click="dialog = true">
                  <v-list-tile-action>
                      Guia Eleições 2026
                  </v-list-tile-action>

              </v-list-tile>

          </v-list>
    </v-navigation-drawer>

    <v-dialog class="dialog"
      v-model="dialog"
      :max-width="window.width - window.width * 0.36"
    >

        <v-card>
            <v-img :src="banner" class="banner">
                
            </v-img>
            <v-btn @click="buttonPrivacy = !buttonPrivacy" v-if="buttonPrivacy" color="secondary" small class="privacy-button">
                Política de Privacidade
            </v-btn>
            <v-card-text class="dialog-text" v-else>
                Ao cadastrar seu email, informamos que ele será utilizado apenas para fins de cadastramento interno, para futuras publicações institucionais do escritório. Nos termos da Lei n. 13.709/2018 (Lei Geral de Proteção de Dados), a Peccinin & Alessi Advocacia realiza o tratamento de dados pessoais em seu site dos dados fornecidos pelo usuário para a finalidade mencionada. O escritório não fornecerá seus dados de email e acesso a terceiros sem consentimento ou autorização do usuário. O usuário poderá entrar em contato para exercício de quaisquer dos seus direitos relacionados aos dados pessoais coletados.            </v-card-text>
           <transition name="fade" mode="out-in">
                <v-card-actions key="1" v-if="!emailSent" >
                    <v-text-field dense filled
                    class="email-insert"
                    v-model="email"
                    background-color="white"
                    label="Insira seu email"></v-text-field>
                    <v-btn @click="saveMail" :loading="sending" color="secondary">Enviar</v-btn>
                </v-card-actions>
                <v-card-actions key="2"  class='btn-download' v-else>
                    <v-btn @click="thank()"  color="secondary">
                        <a  target="_blank" download="GUIA_PRATICO_DAS_ELEIÇÕES_2026.pdf" :href="`${publicPath}GUIA_PRATICO_DAS_ELEIÇÕES_2026.pdf`">
                            Download
                        </a>
                    </v-btn>
                </v-card-actions>
           </transition>
                
        </v-card>
    </v-dialog>

    <v-content>
        <v-container fluid :class="{ 'container-mobile': containerMobile }">
            <router-view /> 
        </v-container>
    </v-content>

    <v-content v-if='$route.path === "/"' id="contato" class="contato">
        <v-container fluid>
            <Contato/>
        </v-container>
    </v-content>

    <v-footer height="auto">
        <v-layout justify-center row wrap>
            <v-flex>
                <!-- Desenvolvido por <a  target="_blank" href="https://www.linkedin.com/in/lucas-gabriel-lima/">Lucas Gabriel Lima</a> -->
            </v-flex>
        </v-layout>
    </v-footer>
  </v-app>
</template>

<script>
import Menu from './components/Menu'
import Contato from './views/Contato'
import banner from './assets/bannerGuia2026.png'
import manutencao_logo from './assets/manutencao_logo.jpeg'
import base from './plugins/firebase'
import router from './router'
import { VApp } from 'vuetify/lib'

export default {
    components:{ VApp, Menu, Contato },

    data () {
        return {
            banner,
            manutencao_logo,
            publicPath: process.env.BASE_URL,
            scrolled: false,
            containerMobile: false,
            snackbar: false,
            drawer: false,
            snackbarText: 'Informe um e-mail válido',
            snackbarTimeout: 3000,
            dialogTimer: 3000,
            dialog: false,
            email: null,
            sending: false,
            emailSent: false,
            buttonPrivacy: true,
            ref: base.database().ref("emails"),
            window: {
                width: 0,
                height: 0
            },
        };
    },
    methods: {
        handleScroll () {
            this.scrolled = window.scrollY > 0;
        },
        handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        },
        invalidEmail(mail) {
            if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.email)) {
                return false
            }
            return true
        },
        thank() {
            let routeData = this.$router.resolve({name: 'obrigado'});
            window.open(routeData.href, '_blank');
        },

        saveMail() {
            if(this.invalidEmail(this.email)){
                this.snackbar = true
                return;
            }

            this.sending = true

            this.ref.push().set({
                    email: this.email
            }).then(res => {
                this.sending = false
                this.emailSent = true
            }, err => {
                this.sending = false
            })
        }
    },
    watch: {
        $route() {
            this.containerMobile = this.$route.path != '/';
        }
    },
    mounted() {
        let thisss = this;
        setTimeout(function() {
            thisss.dialog = thisss.$route.path == '/';
        }, this.dialogTimer);
    },
    created () {
        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('resize', this.handleResize);
        this.handleResize();

        // window.fbq('init', '712228265975783');
        // window.fbq('track', 'PageView')

        this.containerMobile = this.$route.path != '/';
    },
    destroyed () {
        window.removeEventListener('scroll', this.handleScroll);
    }
}
</script>

<style>
    #app{
        display: flex;
        flex-direction: column;
    }

    @media (max-width: 576px){
        .container-mobile {
            padding-left: 20px !important;
            padding-right: 20px !important;
        }

        .v-footer {
            font-size: small;
        }
    }

    .container-mobile {
        padding-bottom: 0px;
    }

    .contato {
        background-color: #383838;
    }

    .banner {
        position: relative;
    }

    @media (min-width: 960px) {
        .v-dialog .banner {
            max-height: calc(90vh - 200px) !important;
            overflow: hidden !important;
        }
    }

    .v-dialog .email-insert {
        padding-bottom: 0px !important;
        padding-right: 5px !important;
    }

    /* .email-insert {
        transform-origin: left;
        position: absolute;
        bottom: 30%;
        left: 66%;
    } */

    .v-footer{
        text-align: center;
        color: white !important;
        background-color: #202020 !important;
    }

    .btn-download{
        color: #fff !important;
        justify-content: center;
    }

    .privacy-button{
         display:block;
         margin-left:auto; 
    }

    .v-footer a:hover{
        color: #6ba348 !important;
    }

    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 1s
    }

    .fade-enter,
    .fade-leave-to {
        opacity: 0;
    }

    .v-dialog__container {
        display: unset;
    }

    .dialog-text {
        font-size: 10px;
    }

    .v-list__tile--link:hover{
        color: #6ba348;
    }

    .container-manutencao {
        text-align: center;
        align-items: center;
        margin-bottom: 36px;
        justify-content: center;
        color: white;
    }

</style>
